export const LocalStorageAuthSession = 'AUTH_SESSION'

export interface AuthState {
  accessToken: string
  refreshToken: string
  userId: string
}
